<template>
  <van-popup
    class="current-van-popup"
    v-model="show"
    :close-on-click-overlay="overlay"
  >
    <div class="message-popup" v-if="!isUnusual && (ok || cancel)">
      <div class="message-popup-title-site" v-if="title">
        <div class="message-popup-title" v-text="title" />
        <div class="message-msg" v-html="msg" />
      </div>
      <div class="message-popup-site" v-else>
        <div class="message-popup-msg" v-html="msg" />
      </div>
      <div class="message-button-site">
        <PopupButton
          class="popup-left popup-smail-button"
          v-if="ok && cancel"
          @click="typeof cancel === 'function' && clickBtn() && cancel()"
        >
          {{ cancelTxt }}
        </PopupButton>
        <PopupButton
          class="popup-right popup-smail-button"
          buttonType="ok"
          v-if="ok && cancel"
          @click="typeof ok === 'function' && clickBtn() && ok()"
        >
          {{ okTxt }}
        </PopupButton>
        <PopupButton
          class="popup-right popup-big-button"
          buttonType="ok"
          v-if="(ok && !cancel) || (cancel && !ok)"
          @click="
            (ok && clickBtn() && ok()) || (cancel && clickBtn() && cancel())
          "
        >
          {{ (ok && okTxt) || (cancel && cancelTxt) }}
        </PopupButton>
      </div>
    </div>
    <div class="error-popup" v-else>
      <span class="position-center message-popup-msg" v-text="msg" />
    </div>
  </van-popup>
</template>

<script>
import { Popup } from "vant";
import PopupButton from "./popup-button";
Vue.use(Popup);
export default {
  components: { PopupButton },
  data() {
    return {
      overlay: false,
      show: false,
      title: "",
      msg: "",
      type: "",
      ok: undefined,
      cancel: undefined,
      okTxt: "",
      cancelTxt: "",
      showLoading: false
    };
  },
  watch: {
    show(val) {
      if (!val) {
        this.$nextTick(() => {
          this.$root.timeout(() => {
            this.type = "";
            this.ok = undefined;
            this.cancel = undefined;
            this.msg = undefined;
            this.okTxt = "";
            this.cancelTxt = "";
            this.showLoading = false;
          }, 500);
        });
      }
    },
  },
  computed: {
    isUnusual() {
      return this.type === "unusual";
    },
  },
  methods: {
    clickBtn() {
      this.show = false;
      return true;
    }
  },
  mounted() {
    Vue.filter("unusual-popup", (isShow, msg, overlay) => {
      if (!this.showLoading && msg) {
        this.showLoading = true;
        this.type = "unusual";
        this.show = !!isShow;
        this.msg = msg || "";
        this.overlay = overlay || false;
      }
    });
    Vue.filter("message-popup", (isShow, params) => {
      if (!this.showLoading && params && params.msg) {
        this.type = "message";
        this.show = !!isShow;
        this.showLoading = true;
        const {
          msg,
          ok,
          cancel,
          okTxt = "ok",
          cancelTxt = "cancel",
          title,
        } = params;
        this.msg = msg || "";
        this.title = title || "";
        this.ok = (typeof ok === "function" && ok) || undefined;
        this.cancel = (typeof cancel === "function" && cancel) || undefined;
        this.okTxt = okTxt;
        this.cancelTxt = cancelTxt;
      }
    });
  },
};
</script>

<style lang="stylus" scoped>
.current-van-popup {
  border-radius: 5px;
  width: 325px;
}

.error-popup {
  width: 100%;
  height: 125px;
  position: relative;
  color: #5D667F;
  font-size: 16px;
}

.message-popup {
  width: 100%;
  position: relative;
  color: #5D667F;
  font-size: 16px;
}

.message-popup-title-site {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  word-break: break-all;
}

.message-popup-title {
  width: 100%;
  padding: 18px;
  padding-bottom: 0;
  color: #333;
  font-size: 16px;
  font-weight: bold;
  overflow: hidden;
}

.message-msg {
  width: 100%;
  padding: 18px;
  font-size: 14px;
  word-break: break-all;
  overflow: hidden;
  line-height 20px;
}

.message-popup-msg {
  width: 100%;
  text-align: center;
  color: #323233;
  font-size: 16px;
  padding: 54.5px 18px;
  word-break: break-all;
  overflow: hidden;
}

.message-popup-site {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
}

.popup-smail-button {
  width: 162px;
  height: 56px;
}

.popup-left {
  float: left;
}

.popup-right {
  float: right;
}

.popup-big-button {
  width: 100%;
  height: 56px;
}
</style>
